export default __webpack_public_path__ + "static/media/SqlServer.910d7552.png";